import { useEffect } from 'react';
import { useCreateResponseTask } from 'services/task/mutations';
import { Button } from 'antd';
import coinPng from 'assets/images/coin-shadow.png';
import { TaskResponse, TaskState } from '../../../../gql/graphql';
import ModalEndSubmit from '../../components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';

interface Props {
  ein: TaskResponse | undefined;
  agreement: TaskResponse | undefined;
  certificate: TaskResponse | undefined;
  goodStanding: TaskResponse | undefined;
  buttonLabel: string;
  closeTask: any;
  listFileUpload: any;
  isModalEdit: boolean;
  setModalEdit: any;
  buttonShow: boolean;
  isConfirmDocs: boolean;
}
const ButtonConfirmDoc = ({
  isModalEdit,
  setModalEdit,
  buttonLabel,
  buttonShow,
  ein,
  agreement,
  certificate,
  goodStanding,
  closeTask
}: Props) => {

  const {
    data: newResponseTask
  } = useCreateResponseTask();

  useEffect(() => { 
    let inReviews = [
      ein,
      certificate,
      agreement,
      goodStanding
    ].filter((item) => item?.state === TaskState.Review);
    
    if (inReviews.length === 3) setModalEdit(true);
  }, [newResponseTask]);
      
  return (
    <>
      {buttonShow && (
        <Button
          className="button button-submit"
          onClick={() => {}}
          disabled={true}
        >
          {buttonLabel}
        </Button>
      )}
      <ModalEndSubmit
        visible={isModalEdit}
        setVisible={setModalEdit}
        buttonAction={{
          label: buttonLabel,
          loading: false,
          className: 'button-submit',
          hidden: true
        }}
        modal={{
          title: `Your entity details are confirmed`,
          description: (
            <h4 className="h4 h4-w4">
              You just completed one of the tasks required to get you approved
              for your loan
            </h4>
          )
        }}
        className=""
        icon={coinPng}
        buttonSubmit={
          <Button
            className="button button-modal-ok"
            onClick={() => {
              closeTask();
              setModalEdit(false);
            }}
          >
            Go to next task
          </Button>
        }
        buttonCancel={
          <Button
            className="button button-modal-cancel"
            onClick={() => {
              closeTask();
              setModalEdit(false);
            }}
          >
            Back to dashboard
          </Button>
        }
      />
    </>
  );
};
export default ButtonConfirmDoc;
